import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { TimeEntryType } from '../../../services/dto/time-entry-type';
import { TimeEntryTypeComponent } from '../../time-entry-type/time-entry-type.component';

@Component({
  host: { 'data-cid': 'grid-time-entry-type-cell' },
  imports: [TimeEntryTypeComponent],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-time-entry-type [type]="this.type"></cam-time-entry-type>
  </div>`,
})
export class GridTimeEntryTypeCellComponent extends AbstractCellComponent<unknown, TimeEntryType> {
  get type() {
    return this.value ?? TimeEntryType.Unknown;
  }
}
